<template>
  <footer class="footer">
    <div class="container">
      <div class="container__elem container__elem--12">
        <div class="footer__inner">
          <div class="footer__content">
            <div class="footer__logo">
              <a href="/">
                <img src="../assets/img/logo.png" alt="logo" />
              </a>
            </div>
            <div class="footer__menu">
              <a v-for="(link, index) in footerLinks" :key="index" :href="link.href" target="_blank"
                rel="noopener noreferrer" class="footer__menu-item">
                {{ link.text }}
              </a>
            </div>
          </div>
          <div class="footer__copy">
            <p class="footer__copy-text">МОЙДВИЖ © 2024 Все права защищены</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footers',
  data() {
    return {
      footerLinks: []
    };
  },
  mounted() {
    fetch('/config.json')
      .then(response => response.json())
      .then(config => {
        this.footerLinks = config.footerLinks;
      })
      .catch(error => {
        console.error('Ошибка загрузки конфигурации:', error);
      });
  }
};
</script>
